'use strict';
import { debounce } from '../../../_js/_helper';
import 'slick-carousel';

export default class Timeline {
  constructor() {

      $(document).ready(function(){

          if($('.js-timeline').length){

             $(() => {
                 let defaultSlickSpeed = 500;

                 $('.views.js-timeline')
                     .slick({
                         speed: defaultSlickSpeed
                     })
             })
          }
        })


  }
}
